import { Settings } from "lucide-react";
import type { Tab } from "@playbookai/ui";
import { SETTINGS_ROUTE } from "../routes.js";

export const SETTINGS_TAB_ID = "settings";

export function settingsTab(route = SETTINGS_ROUTE): Tab {
  return {
    id: SETTINGS_TAB_ID,
    label: "Settings",
    route,
    icon: Settings,
  };
}
